// We are getting a date string from backend like this "2025-09-17T10:21:11.915Z" and we wanna format it to "17.09.2025 10:21" or "17.09.2025"
function formatDate(date, includeTime = true) {
  if (!date) return '';

  const dateInfo = new Date(date);
  const day = dateInfo.getDate();
  const month =
    dateInfo.getMonth() + 1 > 9
      ? dateInfo.getMonth() + 1
      : `0${dateInfo.getMonth() + 1}`;
  const year = dateInfo.getFullYear();

  const fixedDay = day < 10 ? `0${day}` : day;
  const dateString = `${fixedDay}.${month}.${year}`;

  if (!includeTime) {
    return dateString;
  }

  const hour =
    dateInfo.getHours() > 9 ? dateInfo.getHours() : `0${dateInfo.getHours()}`;
  const minutes =
    dateInfo.getMinutes() > 9
      ? dateInfo.getMinutes()
      : `0${dateInfo.getMinutes()}`;

  return `${dateString} ${hour}:${minutes}`;
}

export default formatDate;
